import { render } from "./contact-list-modal.vue?vue&type=template&id=284b749d"
import script from "./contact-list-modal.vue?vue&type=script&lang=js"
export * from "./contact-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__